export default "__VITE_ASSET__BXxcBImg__"